<app-dialog class="email-scenario-dialog" [loading]="loading" [hideClose]="hideClose">
  <ng-container dialog-title>
    {{ 'module.modals.emailScenario.sendEmailScenarioHeaderText' | translate }}
  </ng-container>

  <ng-container dialog-content>
    <app-error-banner *ngIf="isError" warning="{{ 'module.modals.emailScenario.pleaseEnterValidEmailAddressErrorText' | translate }}"> </app-error-banner>
    <input
      *ngIf="!isSaved"
      class="input"
      placeholder="{{ 'module.modals.emailScenario.emailAddressInputPlaceholderText' | translate }}"
      type="text"
      [(ngModel)]="recipients"
    />
    <div class="sent-description" *ngIf="isSaved">
      {{ 'module.modals.emailScenario.yourRequestHasBeenSentDescriptionText' | translate }}
    </div>
  </ng-container>

  <ng-container dialog-actions *ngIf="!isSaved">
    <button class="btn btn-outline-primary -border" (click)="send(recipients)">
      <span class="fa fa-lg fa-envelope"></span>{{ 'module.modals.emailScenario.sendFooterButtonText' | translate }}
    </button>
    <button class="btn btn-outline-secondary" (click)="matDialogRef.close()">
      <span class="fa fa-lg fa-times-circle-o"></span>{{ 'module.modals.emailScenario.stopFooterButtonText' | translate }}
    </button>
  </ng-container>
</app-dialog>
